<div class="modal fade scroll-inside show" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{"studyList.Upload DICOM File" | translate}}
          </h4>

          <button type="button" class="close" aria-label="Close" (click)="closePop()" [disabled]="loading">
            <span>&times;</span>
          </button>
        </div>

        <div class="modal-body">

          <form class="slide-form">
            <div class="form-element">
                <div class="form-group">
                  <label class="mb-2">{{ 'studyList.Upload DICOM File' | translate }}</label>
                    <app-file-manager
                        [files]='files'
                        [isRequired]="true"
                        [managerIndex]='456'
                        [maxFileSize]='100'
                        [isSubmited]="isSubmited"
                        [allowedExt]="['all']"
                        [maxFiles]="10000"
                        [showFilesInfo]="false"
                        (selectedFiles)="files = $event"></app-file-manager>
                </div>
              </div>

            <div class="modal-btns mt-5">
              <button type="reset" class="close closebtn" (click)="closePop()" [disabled]="loading">
                {{ 'swalMsg.cancel' | translate }}
              </button>
              <button mat-raised-button class="btn customBtn px-4" (click)="save()" [disabled]="loading"
                [ngClass]="{ 'loading': loading}">
                {{"group.save" | translate}}
              </button>
            </div>
          </form>

        </div>

      </div>
    </div>
  </div>
